import { gql } from '@/utilities/gql';
import type { FragmentOf } from '@/utilities/gql';

export const NARRATIVE_HEADER_COMPANY_FRAGMENT = gql(`
  fragment NarrativeHeaderCompanyFields on Company @_unmask {
    media {
      transform
      url
    }
  }
`);

export type NarrativeHeaderCompany = FragmentOf<
  typeof NARRATIVE_HEADER_COMPANY_FRAGMENT
>;
